import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		tableZh: [
			{
				name: "个推SDK",
				use: "消息推送、判定网络状态，从而提供如仅在wifi下预加载内容的服务、位置相关信息将有助于我们为您提供线下场景的精细化推送，可以为您推荐更符合您需要的推送内容，减少无用推送消息对您的打扰。",
				userType: "存储的个人文件、设备信息（IMEI、IDFA、MAC、ANDROID_ID、OAID、Google Advertising ID（GAID）、Serial Number、DEVICE_ID、IMSI、ICCID、IDFV、UAID）将被用于生成唯一的推送目标ID(CID)、去标识化的手机号码、位置信息、应用已安装列表、网络信息（BSSID、SSID、IP地址、WIFI信息、基站信息、运营商信息）、此外，为确保CID的唯一性、提升消息推送稳定性和准确性，还需您授权设备权限(READ PHONE STATE)",
				company: "每日互动股份有限公司",
				permissions: "网络信息、位置信息、设备信息、设备权限(READ PHONE STATE)",
				url: "https://docs.getui.com/privacy/",
				collect: "SDK本机采集"
			},
			{
				name: "华为HMS Core SDK",
				use: "华为手机厂商推送",
				userType: "应用内标识符(ADDID、Push、Token)，设备的硬件信息(设备类型)，系统基本信息（系统类型、系统版本），系统设置信息（国家码）BSSID、WIFI、AndroidID",
				company: "华为软件技术有限公司",
				permissions: "应用内设备标识符",
				url: "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177",
				collect: "SDK本机采集"
			},
			{
				name: "魅族 Flyme push",
				use: "魅族手机厂商推送",
				userType: "设备信息（设备名称、设备型号、地区和语言设置、设备识别码（IMEI 号码等）、设备硬件信息与状态、使用习惯、IP 地址、Mac 地址、操作系统版本）、应用信息（应用列表、应用程序版本、应用状态记录（下载、安装、更新、删除）、软件识别码、以及应用设置）、日志信息、位置信息",
				company: "珠海市魅族通讯设备有限公司",
				permissions: "位置信息",
				url: "https://static.meizu.com/resources/term/privacy8.html",
				collect: "SDK本机采集"
			},
			{
				name: "OPPO push",
				use: "OPPO手机厂商推送",
				userType: "设备相关信息（IMEI，OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID，Region设置，设备型号，手机电量，手机操作系统版本及语言）、应用信息（如APP包名及版本号，运行状态）、网络信息",
				company: "广东欢太科技有限公司",
				permissions: "网络信息",
				url: "https://open.oppomobile.com/new/developmentDoc/info?id=10288",
				collect: "SDK本机采集"
			},
			{
				name: "vivo push",
				use: "vivo手机厂商推送",
				userType: "设备标识信息（如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的AndroidID）、应用软件信息（应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络信息",
				company: "维沃移动通信有限公司",
				permissions: "网络信息",
				url: "https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822",
				collect: "SDK本机采集"
			},
			{
				name: "MiPush",
				use: "小米手机厂商推送",
				userType: "设备标识OAID、加密的Android ID、设备信息（设备厂商、设备型号、设备内存、操作系统版本）、网络信息、WiFi状态",
				company: "北京小米移动软件有限公司",
				permissions: "网络信息",
				url: "https://dev.mi.com/distribute/doc/details?pId=1534",
				collect: "SDK本机采集"
			},
			// {
			// 	name: "uni-AD（数字天堂 Dcloud）",
			// 	use: "基础广告、广告投放合作，广告归因、反作弊、安全",
			// 	userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
			// 	company: "数字天堂(北京)网络技术有限公司",
			// 	permissions: "应用安装列表、位置信息、网络信息",
			// 	url: "https://doc.dcloud.net.cn/markdown-share-docs/1d821cdd3cdf2681045ec4be94bc8404/",
			// 	collect: "SDK本机采集"
			// },
			{
				name: "快手广告联盟SDK",
				use: "增强广告、广告投放、广告归因、反作弊、安全、广告交互(摇一摇，滑动等)、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "基础信息：设备品牌、设备型号、软件系统版本、存储信息、运营商信息、设备时区、设备语言、网络信息等基础信息；设备标识：IMEI、MEID、OAID、AndroidID、IMSI、ICCID；位置信息：IP地址、MAC地址、GPS位置信息、基站信息、WIFI信息、SSID、BSSID；应用信息：应用安装列表；其他信息：传感器信息（加速度、重力、陀螺仪传感器等）、sim卡激活信息、WIFI扫描结果",
				company: "北京快手科技有限公司",
				permissions: "网络信息、应用安装列表、位置信息、传感器信息",
				url: ["https://u.kuaishou.com/home/detail/1220", "https://www.kuaishou.com/about/policy?tab=privacy"],
				collect: "SDK本机采集"
			},
			{
				name: "优量汇SDK",
				use: "增强广告、广告投放与监测归因、广告主统计投放结果、减少App崩溃、确保服务器正常运行、提升可扩展性和性能、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "设备信息（设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商；IOS:设备名称、系统启动时间、系统语言、磁盘空间）；Android：OAID、IMEI/MEID（Device ID）、Android_ID、IOS：IDFV、 IDFA）；应用信息（包名、版本号、应用安装信息；Android：进程名称、运行状态、可疑行为）；传感器信息（Andriod：磁力、加速度、重力、陀螺仪传感器；IOS：设备姿态、压力传感器等基础信息）；广告信息（如产品交互数据、广告数据（如展示、点击、转化广告数据））；位置信息（精确位置信息、Andriod：基站、附近的WIFI、连接的WIFI、SSID、BSSID）；诊断数据（如崩溃数据、性能数据）",
				company: "深圳市腾讯计算机系统有限公司",
				permissions: "位置信息、网络信息、应用安装信息",
				url: "https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983",
				collect: "SDK本机采集"
			},
			{
				name: "穿山甲广告SDK",
				use: "增强广告、广告投放合作、广告归因、反作弊、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "【双端】设备MAC地址、设备品牌、型号、软件系统版本、已安装包名列表、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小等基础信息、运营商信息、Wi-Fi状态、网络信号强度、IP地址、加速度传感器、陀螺仪传感器、对广告的展示、点击及转化等交互数据、精确位置信、粗略位置信息（WiFi列表、WLAN接入点（如SSID，BSSID）、基站）、如崩溃数据、性能数据;【仅Android】AndroidID、OAID;【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV;【仅Android】设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、硬件序列号build_serial，具体字段因软硬件版本不同而存在差异）、应用包名、运行中的进程信息、版本号、应用前后台状态、软件列表信息、线性加速度传感器、磁场传感器、旋转矢量传感器;",
				company: "北京巨量引擎网络技术有限公司",
				permissions: "网络信息、传感器信息、位置信息",
				url: "https://www.csjplatform.com/privacy/partner",
				collect: "SDK本机采集"
			},
			{
				name: "Sigmob SDK",
				use: "增强广告、广告投放合作、广告归因、反作弊、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "**设备信息：**设备品牌、型号、操作系统版本、OAID、AndroidID 、GAID、IMEI、分辨率等基础设备信息、**应用信息：**应用名称、应用包名、应用版本号等、**其他：**运营商信息、时区、广告业务必要信息】、设备信息： 设备品牌、型号、操作系统版本、分辨率等基础设备信息、应用信息：应用名称、应用包名、应用版本号等、其他：运营商信息、国家/时区、手机系统重启时间、磁盘空间、内存空间、sim卡信息（mcc&mnc）等、【可选信息】（开发者可以基于优化广告效果的目的选择授权给Sigmob读取）、地理位置、IDFA、【仅iOS 2.21.0以上版本】、手机系统重启时间、系统更新时间、磁盘空间、内存空间、设备名称等、**传感器信息列表**：传感器开关：线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器",
				company: "北京创智汇聚科技股份有限公司",
				permissions: "网络信息、传感器信息、位置信息、设备信息",
				url: "https://www.sigmob.com/policy.html",
				collect: "SDK本机采集"
			},
			// {
			// 	name: "推啊",
			// 	use: "基础广告、识别广告、活动作弊行为；改善 SDK 崩溃率、推送个性化广告；广告投放。",
			// 	userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
			// 	company: "杭州推啊网络科技有限公司",
			// 	permissions: "位置信息、网络信息、应用安装信息",
			// 	url: "https://yun.tuia.cn/tuia/sdk/agreement/index.html",
			// 	collect: "SDK本机采集"
			// },
			{
				name: "章鱼广告",
				use: "增强广告、广告投放统计分析(如广告加载、展示、点击等）、反作弊、提升SDK的稳定性，减少APP的崩溃、推送个性化广告、广告归因、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "设备品牌、设备型号、设备时区、设备语言、系统版本、开发者应用名、应用版本号、应用包名、网络类型、UserAgent信息、网络状态、崩溃信息、性能数据、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、[仅Android]、设备ID（OAID、GAID）、IMEI 用户授权才收集、USB调试模式、cpu、运行状态、[仅ios]、设备ID（IDFA 用户授权才收集）、IDFV、获取信息（并未收集）：、传感器信息（例如：重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、重力传感器、线性加速度传感器等）、掠过手势内容",
				company: "北京圣盈科技有限公司及其关联方",
				permissions: "位置信息、设备信息、传感器信息、网络信息、应用安装信息、广告信息、性能数据",
				url: "https://doc.adintl.cn/#/zh-cn/guide/UsePrivacy",
				collect: "SDK本机采集"
			},
			{
				name: "倍孜广告 SDK",
				use: "增强广告、广告投放策略、统计分析服务、反作弊分析、广告正常显示与交互功能的实现、广告归因、最大程度减少App崩溃、确保服务器正常运行、提升可扩展性和性能",
				userType: "设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、sim卡状态、精确位置信息、粗略位置信息、传感器信息（重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、线性加速度传感器、磁力传感器）、掠过手势内容、IDFA、IDFV、cpu、设备ID(国内用户OAID、海外用户GAID)、开发者应用名、应用版本号、应用包名、运行状态、使用数据、诊断数据",
				company: "上海倍孜网络技术有限公司",
				permissions: "位置信息、应用安装信息、设备信息、网络信息、系统信息、传感器信息",
				url: "https://sdkdoc.beizi.biz/#/zh-cn/guide/AllPrivacy",
				collect: "SDK本机采集"
			},
			{
				name: "Google AdMob(谷歌广告)",
				use: "增强广告、广告投放合作、广告归因、反作弊、安全",
				userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
				company: "上海神著信息科技有限公司",
				permissions: "位置信息、网络信息、应用安装信息",
				url: "https://policies.google.com/privacy",
				collect: "SDK本机采集"
			},
			{
				name: "AdsPlus SDK",
				use: "广告投放",
				userType: "设备信息(IMEI、AndroidID、OAID、SN)、Mac地址、应用信息(应用崩溃信息、通知开关状态、软件列表等相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)、网络信息:IP地址，无线网SSID名称、WiFi路由器MAO地址(BSSID)、设备的MAC地址、基站信息等相关信息、位置信息、陀螺仪传感器信息、加速度传感器信息、重力传感器信息",
				company: "广州聚通云媒信息科技有限公司",
				permissions: "位置信息、设备标识",
				url: "https://www.adsplus.cn/privacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "百度SDK",
				use: "广告投放、广告监测、广告归因、反作弊功、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "设备信息（品牌、型号、系统版本、分辨率、网络信号强度、传感器信息，磁盘总空间、系统总内存空间、手机重启信息、手机系统更新时间等基础信息、OAID、AndroidID、日志信息、IMEI、IMSI、MEID屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商，手机网络状态，设备剩余存储空间，手机重启时间和更新时间）、应用信息、网络信息：IP地址，WiFi路由器MAC地址（BSSID）、设备的MAC地址，基站信息等相关信息、位置信息",
				company: "北京百度网讯科技有限公司",
				permissions: "网络信息、设备信息、应用安装列表（Android）、传感器信息、位置信息、广告标识符(IDFA)",
				url: "https://union.baidu.com/bqt/#/legal/policies",
				collect: "SDK本机采集"
			},
			{
				name: "京媒SDK",
				use: "广告投放、广告监测、广告归因、反作弊功",
				userType: "设备信息（IMEI、AndroidID、OAID、SN）、Mac地址、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息：IP地址，WiFi路由器MAC地址（BSSID）、设备的MAC地址，基站信息等相关信息、位置信息、陀螺仪传感器信息，加速度传感器信息",
				company: "重庆京东海嘉电子商务有限公司",
				permissions: "位置信息、设备信息、广告信息、性能数据、应用安装信息、传感器信息",
				url: "https://opendoc.jd.com/janGroup/help/agreement/privacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "鲸鸿动能SDK",
				use: "广告投放、广告监测、广告归因、反作弊功",
				userType: "设备信息（IMEI、AndroidID、OAID、SN）、Mac地址、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息：IP地址，WiFi路由器MAC地址（BSSID）、设备的MAC地址，基站信息等相关信息、位置信息、陀螺仪传感器信息，加速度传感器信息",
				company: "华为软件技术有限公司",
				permissions: "位置信息、网络信息、设备标识符（包含OAID）、应用安装信息",
				url: "https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582",
				collect: "SDK本机采集"
			},
			{
				name: "Tanx SDK",
				use: "广告投放、广告监测、广告归因、反作弊功",
				userType: "设备信息(IMEI、AndroidID、OAID、SN)、Mac地址、应用信息(应用崩溃信息、通知开关状态、软件列表等相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)、网络信息:IP地址，无线网SSID名称、WiFi路由器MAO地址(BSSID)、设备的MAC地址、基站信息等相关信息、位置信息、陀螺仪传感器信息、加速度传感器信息、重力传感器信息",
				company: "杭州易宏广告有限公司",
				permissions: "位置信息、设备标识符、应用安装信息",
				url: "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_ali_mama_division/suit_bu1_ali_mama_division202202171548_47251.html?spm=a2e1xn.27152719.c4bf85e4b.15.2cfc52aa8SYFyp",
				collect: "SDK本机采集"
			},
			{
				name: "Admob SDK",
				use: "增强广告、广告投放合作、广告归因、反作弊、安全",
				userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
				company: "Google LLC",
				permissions: "位置信息、网络信息、应用安装信息",
				url: "https://policies.google.com/privacy?hl=zh&gl=CN#intro",
				collect: "SDK本机采集"
			},
			{
				name: "Facebok SDK",
				use: "广告投放合作、广告归因、反作弊、安全",
				userType: "Mac地址、应用信息、设备参数及系统信息（IMEI、AndroidID、SN）、网络信息：IP地址，WiFi信息、基站信息等相关信息、位置信息、重力传感器信息",
				company: "Facebook, Inc",
				permissions: "位置信息、网络信息、应用安装信息",
				url: "https://www.facebook.com/privacy/policy/",
				collect: "SDK本机采集"
			},
			{
				name: "阿里云 Log SDK",
				use: "广告投放合作、广告归因、反作弊、安全",
				userType: "设备信息、Mac地址、应用信息、设备参数及系统信息、网络信息：IP地址，无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址、基站信息等相关信息、位置信息、陀螺仪传感器信息、加速度传感器信息、重力传感器信息",
				company: "阿里云计算有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息",
				url: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=5176.smartservice_service_robot_chat_new.0.0.257c3a98BIU6PT",
				collect: "SDK本机采集"
			},
			{
				name: "Taku Android SDK",
				use: "广告投放合作、广告归因、反作弊、安全、减少App崩溃、提供稳定可靠的服务、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "系统版本名、系统版本号、当前应用包名、应用版本名、应用版本号、设备生产商、设备型号、分辨率、网络类型，例：WiFi/3G/4G、MNC、MCC、系统语言、时区、时间戳、user_agent信息、屏幕方向、设备id、应用安装来源、设备总内存、设备CPU核数、设备存储空间、设备CPU信息、电量信息、设备id(android_id)、imei（用户授权才收集）、oaid、mac地址、wifi ssid、imsi、gaid(google advertising id)、设备传感器信息",
				company: "广州塔酷信息科技有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息、传感器信息、广告信息、性能数据、设备标识符",
				url: "https://help.takuad.com/docs/1Mn1B7",
				collect: "SDK本机采集"
			},
			{
				name: "趣盟广告SDK",
				use: "广告投放合作、广告监测归因、广告投放统计分析、广告反作弊、减少App崩溃、提供稳定可靠的服务、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "【Android】设备品牌、型号、软件系统版本、分辨率、网络状态、加速度传感器、重力传感器等基础信息、设备的MAC地址、蓝牙地址、设备标识符（IMEI、AndroidID、OAID、IMSI、ICCID、MEID，具体字段因软硬件版本不同而存在差异）应用信息：开发者应用名、应用包名、版本号、应用前后台状态、应用安装列表等信息其他信息：运营商信息、设备时区、设备语言",
				company: "湖北捷兔信息科技有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息、传感器信息、广告信息、性能数据",
				url: "https://docs.jietuhb.com/android_sdk/qu-privacy-agreement.html",
				collect: "SDK本机采集"
			},
			{
				name: "上海领页广告 SDK",
				use: "广告投放合作、广告监测归因、广告投放统计分析、广告反作弊、减少App崩溃、提供稳定可靠的服务、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "设备信息：设备品牌、型号、操作系统版本、OAID、AndroidId、分辨率等基础设备信息、设备语言、设备时区、sim卡信息(mcc&mnc)、CPU信息、可用存储空间大小等基础信息、应用信息：应用名称、应用包名、应用版本号等",
				company: "上海领页信息技术有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息、传感器信息、广告信息、性能数据、设备标识符",
				url: "https://user.wxcjgg.cn/privacy",
				collect: "SDK本机采集"
			},
			{
				name: "奇运sdk",
				use: "广告投放合作、广告监测归因、广告投放统计分析、广告反作弊、减少App崩溃、提供稳定可靠的服务、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "必选信息：【双端】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、屏幕背光、sim卡信息（mcc&mnc）、设备语言、设备时区、CPU信息、可用存储空间大小基础信息、【仅Android】AndroidID、OAID、【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV；可选信息：【仅Android】设备标识符（如IMEI），具体字段因软硬件版本不同而存在差异）、【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）；必选信息：【双端】运营商信息、Wi-Fi状态、网络信号类型、必选信息：【仅Android】宿主的应用包名、运行中的进程信息、版本号、应用前后台状态、可选信息：【双端】加速度传感器、陀螺仪传感器",
				company: "杭州奇运网络科技有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息、传感器信息、广告信息、性能数据、设备标识符",
				url: "http://ag.xiangshu18.com/jySdkPrivacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "脉盟SDK",
				use: "广告投放合作、广告归因、反作弊、广告监测、个性化广告推荐、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "【Android】设备品牌、型号、软件系统版本、分辨率、网络状态、加速度传感器、重力传感器等基础信息、设备的MAC地址、蓝牙地址、设备标识符（IMEI、AndroidID、OAID、IMSI、ICCID、MEID，具体字段因软硬件版本不同而存在差异）应用信息：开发者应用名、应用包名、版本号、应用前后台状态、应用安装列表等信息其他信息：位置信息、运营商信息、设备时区、设备语言",
				company: "上海孛樊信息科技有限公司",
				permissions: "设备信息、位置信息、网络信息、应用信息、传感器信息、性能数据、设备标识符、广告信息",
				url: "https://static.adwangmai.com/privacy-MaxMindSDK.html",
				collect: "SDK本机采集"
			},
			{
				name: "猫广告 SDK",
				use: "广告投放合作、摇一摇、扭一扭等广告投放、广告监测归因、广告投放统计分析、反作弊、减少App崩溃、提供稳定可靠的服务",
				userType: "设备信息：设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息等基础信息、无线网SSID名称、WiFi路由器MAC地址、设备的MAC地址；【仅Android】AndroidID、设备标识符（如IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial）；【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV、设备标识符（如IDFV、 IDFA）；其他信息（运营商信息、设备时区）、传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器）、广告信息（对广告的展示、点击及转化等交互数据）、性能数据（如崩溃数据、性能数据）",
				company: "杭州三脚猫网络科技有限公司",
				permissions: "位置信息、网络信息、设备信息、系统信息、应用安装信息、广告信息、传感器信息、性能数据、设备标识符",
				url: "http://sdk.hzsanjiaomao.com/sdkdoc/index/maojuhyinsi.html",
				collect: "SDK本机采集"
			},
			{
				name: "Mintegral Android SDK",
				use: "广告投放合作、精准投放、广告监测归因、反作弊、广告主/广告代理进行结算（就该等个人信息处理活动而言，Mintegral作为处理者代表广告主/广告代理处理用户的个人信息）",
				userType: "①位置信息：IP地址；②设备/广告ID：国际移动设备识别码（IMEI）、安卓ID、OAID、IDFV，移动广告标识符（如苹果IDFA、谷歌广告ID及亚马逊ID）、MAC地址；③设备信息：设备生产商，设备型号，设备的操作系统信息，设备类型，设备屏幕信息，设备电池信息，设备音量及字体大小，是否为模拟器，设备网络信息，设备传感器信息，限制广告追踪（LAT）状态，手机开机时间，手机用户名摘要；④应用信息：Mintegral合作方的应用包名，应用版本和特性，是否为App Store下载，SDK版本；⑤使用数据：浏览、点击了该广告的相关信息；⑥其他信息：用户代理",
				company: "广州汇世信息科技有限公司",
				permissions: "位置信息、网络信息、应用信息、设备信息、设备/广告ID、广告信息",
				url: "https://www.mintegral.com/cn/privacy",
				collect: "SDK本机采集"
			},
			{
				name: "MMA 中国广告监测通用SDK",
				use: "广告投放合作、广告测量、第三方必须采集项、广告监测归因、反作弊",
				userType: "设备信息（用户的移动设备和智能电视配置信息和设备标识码，包括硬件类型（机型）、屏幕尺寸、IMEI、MAC、 IDFA、AAID、OAID）、系统信息（系统类型、系统版本号）、设备标识信息（OAID、IMEI、AndroidID等）、网络信息（连接的WIFI、MAC地址等）、位置信息（经维度）、应用信息（软件唯一标识符名称、软件版本、签名字符串）",
				company: "上海亦拓广告有限公司",
				permissions: "位置信息、网络信息、系统信息、应用信息、设备信息、设备标识信息",
				url: "https://mmachina.cn/sdk-privacy/",
				collect: "SDK本机采集"
			},
			{
				name: "百青藤 SDK",
				use: "广告投放合作、增强广告、广告监测归因、反作弊功保障服务稳定安全",
				userType: "设备信息：设备品牌、型号、软件系统版本、分辨率、网络信号强度、传感器信息，磁盘总空间、系统总内存空间、手机重启信息、手机系统更新时间等基础信息、OAID、AndroidID、屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商，手机网络状态，设备剩余存储空间，手机重启时间和更新时间 开发者应用信息：应用包名、应用前后台状态 设备信息：IMEI、IMSI、MEID、位置信息、崩溃数据、性能数据",
				company: "北京百度网讯科技有限公司",
				permissions: "位置信息、网络信息、应用信息、设备信息、广告信息、性能数据",
				url: "https://union.baidu.com/bqt/#/legal/policies",
				collect: "SDK本机采集"
			},
			{
				name: "网易七鱼SDK",
				use: "广告推荐、归因及反作弊场景统计，如虚假流量识别等",
				userType: "协议版本号、平台、包名、操作系统版本、Model 、APP版本号、序列号、手机品牌、硬件序列号、SIM卡、网络状态、系统设置、系统属性、设备型号、操作系统、IP地址、运营商信息、标识符如OAID、IDFA、IDFV等，由第三方开发者根据实际情况决定是否采集并传输给SDK，SDK采取去标识、加密等方式进行处理",
				company: "网易易盾",
				permissions: "位置信息、网络信息、应用信息、设备信息、设备标识信息",
				url: "https://support.dun.163.com/documents/413846598587424768?docId=507376333387018240",
				collect: "SDK本机采集"
			},
			{
				name: "inmobi SDK",
				use: "广告投放合作、广告监测归因、反作弊",
				userType: "获取粗略位置、设备信息（IDFA）、设备ID（OAID、GAID、IDFV、IMEI与IDFA 用户授权才收集）、移动运营商、网络提供商或ISP、网络类型（如WiFi或蜂窝）、网络状态、手机WiFi状态、安装应用、应用列表、IP地址、应用程序标识符、SDK版本、设备类型（例如制造商和型号）、屏幕尺寸、操作系统（例如iOS、Android、Windows、黑莓）、使用的移动浏览器（例如Chrome、Safari、Firefox）、语言设置和时区",
				company: "上海邑盟信息技术（上海）有限公司",
				permissions: "位置信息、网络信息、应用信息、设备信息、广告信息",
				url: "https://www.inmobi.cn/privacy-policy/",
				collect: "SDK本机采集"
			},
			{
				name: "酷盈 Android SDK",
				use: "基于用户设备信息调整广告投放策略、基于用户设备信息分析广告行为(如广告加载、展示、点击等）、反作弊、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "必要信息：【Android+iOS+HarmonyOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、限制广告追踪（LAT）状态、CPU信息、可用存储空间大小等基础信息【Android】AndroidID、OAID【iOS】：手机系统重启时间、磁盘总空间、系统总内存空间、IDFV【HarmonyOS】ODID; 可选信息：【Android+iOS+HarmonyOS】CPU类型、设备电池电量信息、设备音量及字体大小、是否为模拟器、是否usb链接、是否开发者模式、系统启动程序版本号、硬件名称，主机地址，系统开发代号、系统源码控制版本号、设备显示的版本号、设备基板名称【Android+HarmonyOS】：国际移动设备识别码（IMEI）、MAC地址、国际移动用户识别码（IMSI）【Android】硬件序列号build_serial，具体字段因软硬件版本不同而存在差异）【iOS】：设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）【HarmonyOS】：OAID必要信息：【Android+iOS+HarmonyOS】运营商信息、Wi-Fi状态、网络信号强度;必要信息：【Android+iOS+HarmonyOS】IP地址;必要信息：【Android+HarmonyOS】Taku 合作方的应用包名、运行中的进程信息、版本号、应用前后台状态、SDK 版本号;可选信息：【Android】软件列表信息，是否为应用商店下载;可选信息：【Android】线性加速度传感器【iOS+HarmonyOS】加速度传感器、陀螺仪传感器;必选信息：【Android+iOS+HarmonyOS】对广告的展示、点击及转化等交互数据;可选信息：【Android+HarmonyOS】粗略位置信息（WLAN接入点（如SSID））;必选信息：【Android+iOS+HarmonyOS】如崩溃数据、性能数据",
				company: "广州数链通信息技术有限公司",
				permissions: "设备信息、网络信息、应用信息、传感器信息、广告信息、位置信息、设备标识信息",
				url: "https://www.statisticslinks.com/privacy-policy",
				collect: "SDK本机采集"
			},
			{
				name: "早范广告SDK",
				use: "广告投放、广告归因、广告监测、反作弊、向用户推荐广告",
				userType: "设备信息：【双端】设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息等基础信息【仅Android】AndroidID【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV，您可以基于广告投放效果优化的目的需要选择是否向我方提供如下信息：【双端】无线网SSID名称【仅Android】设备标识符（如IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）；应用信息：【仅Android】开发者应用名、应用包名、运行中的进程信息、版本号、应用前后台状态，您可以基于广告投放效果优化的目的需要选择是否向我方提供：【仅Android】软件列表信息；广告信息：【双端】对广告的展示、点击及转化等交互数据；位置信息：您可以基于广告投放效果优化的目的需要选择是否向我方提供如下信息：位置信息；其他信息：运营商信息、设备时区",
				company: "杭州早范传媒有限公司",
				permissions: "设备信息、网络信息、应用信息、传感器信息、麦克风权限、位置信息、设备标识信息",
				url: "http://ag.hzzfcm.com/zfSdkPrivacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "爱奇艺广告SDK",
				use: "广告投放、反作弊、用于广告投放时",
				userType: "设备信息：【双端】设备品牌、型号、系统版本、Mac地址，设备语言、网络类型、WiFi名称、IP地址、电池容量、物理内存、硬盘容量、系统语言、运营商信息等基础信息【仅Android】CUP类型、IMEI、AndroidID【仅iOS】运营商信息、开机时间、系统更新时间、磁盘容量、CPU数量、内存容量、设备名称、地区名称、时区、OpenUdid、IDFV，基于优化广告投放目的选择是否提供：【仅Android】OAID【仅iOS】IDFA；应用信息：【仅Android】：应用名称、包名、版本号【仅iOS】：应用bundleId，基于广告投放优化目的选择是否提供：【仅Android】应用列表信息",
				company: "北京爱奇艺科技有限公司",
				permissions: "设备信息、网络信息、应用信息、传感器信息、广告信息、位置信息、设备标识信息",
				url: "https://union.iqiyi.com/platform/privacyPolicy",
				collect: "SDK本机采集"
			},
			{
				name: "青云广告SDK",
				use: "广吿投放、广告归因、广告监测、反作弊、用于广告投放时",
				userType: "设备信息：【双端】设备制造商、设备型号、操作系统版本、屏幕分辫率、屏幕方向、屏幕DPI、 IP地址、加速度传感器【仅Android】磁场传感器【仅iOS】设备名称、系统启动时间、系统语言、磁盘空间、陀螺仪、压力传感器等基础信息；粗略位置信息：【仅Android］基站、附近的WIFI、连接的WIFI第三方开发者可以选择是否向本SDK 提供如下信息：【双端】精确位置信息；必选信息：【双端】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息、CPU信息、可用存储空间大小等基础信息【仅Android】AndroidID、OAID【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV；可选信息：【双端】无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址（如为iOS端，则仅适用于IOS3200以下版本）【仅Android】设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）；应用信息：【双端】宿主应用的包名、版本号【仅Android】宿主应用的进程名條、运行状态、可疑行为",
				company: "北京沄沄科技有限公司",
				permissions: "设备信息、网络信息、应用信息、传感器信息、广告信息、位置信息、设备标识信息",
				url: "https://ssp.qyzss.com/privacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "微信开放平台",
				use: "应用内商品支付、微信分享",
				userType: "设备型号、操作系统、唯一设备标识符、登录IP地址、微信软件版本号、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、存储的个人文件、网络信息",
				company: "深圳市腾讯计算机系统有限公司",
				permissions: "设备加速器、IP地址",
				url: "https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy",
				collect: "SDK本机采集"
			},
			{
				name: "支付宝开放平台(支付宝SDK)",
				use: "应用内商品支付",
				userType: "网络信息 设备id IP地址 OAID IMSI",
				company: "支付宝(中国)网络技术有限公司",
				permissions: "网络信息 ",
				url: "https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132",
				collect: "SDK本机采集"
			},
			{
				name: "移动安全联盟 OAID（移动智能终端补充设备标识体系统一调用SDK）",
				use: "获取OAID(提供不同移动智能终端开放匿名设备标识符（OAID），用于移动安全联盟推送设备OAID生成唯一标识、广告投放合作、广告归因、反作弊、广告监测)、设备标识符（VAID）、设备标识符（AAID）、设备网络运营商名称、设备信息、App包名及签名信息，或在对应应用商店的APPID",
				// use: "获取OAID，在用户使用 APP 时收集设备 OAID 唯一标识、设备标识符（VAID）、设备标识符（AAID）、设备网络运营商名称、设备信息、App包名及签名信息，或在对应应用商店的APPID",
				userType: "设备信息、网络信息、品牌信息、应用软件信息、设备标识符(OAID)",
				company: "中国信息通信研究院",
				permissions: "/",
				url: "https://www.msa-alliance.cn/col.jsp?id=122",
				collect: "SDK本机采集",
				tips: "移动智能终端补充设备标识体系与 SDK 严格遵守我国《网络安全法》、《数据安全法》和《电信和互联网用户个人信息保护规定》等相关法律法规和《信息安全技术 个人信息安全规范》等国家标准要求。SDK 不会主动收集任何数据，只在 APP 调用时获取以下数据，用于本地判断，不会进行任何网络传输：</br></br> • 设备制造商、设备型号、设备品牌，用于判断终端调用接口</br> • 设备网络运营商名称，用于判断虚拟机环境</br> • APP 包名，用于校验签名"
			},
			{
				name: "fastjson",
				use: "无",
				userType: "JSON解析",
				company: "/",
				permissions: "/",
				url: "https://github.com/alibaba/fastjson",
				collect: "SDK本机采集"
			},
			{
				name: "glide图库",
				use: "存储的个人文件",
				userType: "用于图片预览使用",
				company: "/",
				permissions: "存储的个人文件",
				url: "http://bumptech.github.io/glide/",
				collect: "SDK本机采集"
			},
			{
				name: "阿里weexSDK",
				use: "uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎",
				userType: "读取外置存储器、写入外置存储器",
				company: "/",
				permissions: "存储的个人文件",
				url: "http://doc.weex.io/zh/",
				collect: "SDK本机采集"
			},
			{
				name: "fresco图片库",
				use: "uni-app基础模块默认集成，用于nvue页面加载图片使用",
				userType: "读取外置存储器、写入外置存储器",
				company: "/",
				permissions: "存储的个人文件",
				url: "https://www.fresco-cn.org/",
				collect: "SDK本机采集"
			},
			{
				name: "netty",
				use: "网络通讯框架（https://netty.io）",
				userType: "网络信息(IP地址)",
				company: "/",
				permissions: "网络信息(IP地址)",
				url: "https://github.com/Bilibili/DanmakuFlameMaster",
				collect: "/"
			},
			{
				name: "DanmakuFlameMaster",
				use: "Android开源弹幕引擎·",
				userType: "/",
				company: "/",
				permissions: "/",
				url: "/",
				collect: "/"
			},
			{
				name: "zip4j",
				use: "Java处理zip压缩文件的完整解决方案",
				userType: "/",
				company: "/",
				permissions: "/",
				url: "/",
				collect: "/"
			}
		]
	},
	mutations: {},
	actions: {},
	modules: {}
})